import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { DataLayerService } from '../../../framework/analytics/datalayer.service'

@Component({
    selector: 'mg-root',
    template: '<mg-routing-loading-status></mg-routing-loading-status><router-outlet></router-outlet>',
    styleUrls: ['../../../scss/globals.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class AppComponent implements OnInit {
    constructor(private router: Router, private dataLayerService: DataLayerService) {}

    ngOnInit(): void {
        this.router.events.subscribe(evt => {
            if (!(evt instanceof NavigationEnd)) {
                return
            }

            this.dataLayerService.push({
                event: 'page.view',
                'content-name': location.pathname + location.search,
            })
        })
    }
}
